<section class="section-div">
  <div class="content-details mb-3">
    <form action="" [formGroup]="budget">
      <div>
        <table class="table">
          <thead
            style="
              padding: 18px;
              background-color: #0c0249;
              color: white;
              text-align: center;
              border-top-left-radius: 20px;
              border-bottom-left-radius: 20px;
            "
          >
            <tr>
              <th scope="col" style="width: 20px">S.No</th>
              <th scope="col" style="width: 150px">Expenditure Heads*</th>
              <th scope="col" style="width: 150px">Year 1</th>
              <th scope="col" style="width: 150px">Year 2</th>
              <th scope="col" style="width: 150px">Total</th>
              <th scope="col" style="width: 200px">Justification</th>
            </tr>
          </thead>
          <tbody
            style="
              background-color: #fff;
              text-align: center;
              border-top-left-radius: 20px;
              border-bottom-left-radius: 20px;
            "
          >
            <tr>
              <th scope="row" class="pt-4"></th>
              <td></td>
              <td></td>
              <td class="pt-4 text-center"><b>1.Non-Recurring</b></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">a</th>
              <td class="pt-4 text-left">
                <div style="width: 150px">
                  <p>
                    Establishment of equipment relevant to thrust area and pilot
                    facilities
                  </p>
                </div>
              </td>
              <td>
                <div class="form-rows" style="width: 150px">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownEstablishmentEquipmentYear1"
                      (input)="calculateTotal1()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows" style="width: 150px">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownEstablishmentEquipmentYear2"
                      (input)="calculateTotal1()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows" style="width: 150px">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownEstablishmentEquipmentTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows file-width" *ngIf="!showForm">
                  <label
                    *ngIf="disName != '✔ Uploaded'"
                    for="input-file-id"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName }}</span>
                    <input
                      class="d-none"
                      id="input-file-id"
                      type="file"
                      (change)="fileUpload($event)"
                    />
                  </label>
                  <label
                    *ngIf="disName == '✔ Uploaded'"
                    for="input-file-id"
                    class="md-button md-raised md-accent"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName }}</span>
                    <input
                      class="d-none"
                      id="input-file-id"
                      type="file"
                      (change)="fileUpload($event)"
                    />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p *ngIf="fileErrorShow == true" class="text-danger">
                    File size exceeds the limit ({{ maxSizeMB }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
                <div class="form-rows file-width" *ngIf="showForm" disabled>
                  <label
                    *ngIf="disName != '✔ Uploaded'"
                    for="input-file-id"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName }}</span>
                    <input class="d-none" id="input-file-id" readonly />
                  </label>
                  <label
                    *ngIf="disName == '✔ Uploaded'"
                    for="input-file-id"
                    class="md-button md-raised md-accent"
                    style="cursor: not-allowed"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName }}</span>
                    <input class="d-none" id="input-file-id" readonly />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p
                    *ngIf="
                      logoCheck &&
                      selecetdFile &&
                      selecetdFile.size / (1024 * 1024) > maxSizeMB
                    "
                    class="text-danger"
                  >
                    File size exceeds the limit ({{ maxSizeMB }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">b</th>
              <td class="pt-4 text-left">
                Office equipment including computers, printers and another
                communication network with installations
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownOfficeEquipmentYear1"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownOfficeEquipmentYear2"
                      (input)="calculateTotal2()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownOfficeEquipmentTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div
                  class="form-rows mt-3 file-width"
                  *ngIf="!showForm"
                  style="width: 238px"
                >
                  <label
                    *ngIf="disName2 != '✔ Uploaded'"
                    for="input-file-id2"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName2 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id2"
                      type="file"
                      (change)="fileUpload2($event)"
                    />
                  </label>
                  <label
                    *ngIf="disName2 == '✔ Uploaded'"
                    for="input-file-id2"
                    class="md-button md-raised md-accent"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName2 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id2"
                      type="file"
                      (change)="fileUpload2($event)"
                    />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p *ngIf="fileErrorShow2 == true" class="text-danger">
                    File size exceeds the limit ({{ maxSizeMB2 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames2 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName2 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>

                <div
                  class="form-rows file-width mt-3"
                  *ngIf="showForm"
                  disabled
                >
                  <label
                    *ngIf="disName2 != '✔ Uploaded'"
                    for="input-file-id2"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName2 }}</span>
                    <input class="d-none" id="input-file-id2" readonly />
                  </label>
                  <label
                    *ngIf="disName2 == '✔ Uploaded'"
                    for="input-file-id2"
                    class="md-button md-raised md-accent"
                    style="cursor: not-allowed"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName2 }}</span>
                    <input class="d-none" id="input-file-id2" readonly />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p
                    *ngIf="
                      logoCheck2 &&
                      selecetdFile2 &&
                      selecetdFile2.size / (1024 * 1024) > maxSizeMB2
                    "
                    class="text-danger"
                  >
                    File size exceeds the limit ({{ maxSizeMB2 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames2 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName2 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td class="pt-4 text-right">Total(1)</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownNonRecurryingYear1Total"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownNonRecurryingYear2Total"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownNonRecurryingTotal"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td></td>
              <td></td>
              <td class="pt-4 text-right"><b>2.Recurring - 2 Years</b></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <th class="pt-4">a</th>

              <td class="pt-4 text-left">
                <p class="mt-2">Full-time dedicated team</p>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td class="pt-4 text-left">i. Vice President - One</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingvpYear1"
                      (input)="calculateTotal3()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingvpYear2"
                      (input)="calculateTotal3()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownRecurryingvpTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div
                  class="form-rows file-width mt-3"
                  *ngIf="!showForm"
                  style="width: 238px"
                >
                  <label
                    *ngIf="disName3 != '✔ Uploaded'"
                    for="input-file-id3"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName3 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id3"
                      type="file"
                      (change)="fileUpload3($event)"
                    />
                  </label>
                  <label
                    *ngIf="disName3 == '✔ Uploaded'"
                    for="input-file-id3"
                    class="md-button md-raised md-accent"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName3 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id3"
                      type="file"
                      (change)="fileUpload3($event)"
                    />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p *ngIf="fileErrorShow3 == true" class="text-danger">
                    File size exceeds the limit ({{ maxSizeMB3 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames3 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName3 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>

                <div
                  class="form-rows file-width mt-3"
                  *ngIf="showForm"
                  style="width: 238px"
                  disabled
                >
                  <label
                    *ngIf="disName3 != '✔ Uploaded'"
                    for="input-file-id3"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName3 }}</span>
                    <input class="d-none" id="input-file-id3" readonly />
                  </label>
                  <label
                    *ngIf="disName3 == '✔ Uploaded'"
                    for="input-file-id3"
                    class="md-button md-raised md-accent"
                    style="cursor: not-allowed"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName3 }}</span>
                    <input class="d-none" id="input-file-id3" readonly />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p
                    *ngIf="
                      logoCheck3 &&
                      selecetdFile3 &&
                      selecetdFile3.size / (1024 * 1024) > maxSizeMB3
                    "
                    class="text-danger"
                  >
                    File size exceeds the limit ({{ maxSizeMB3 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames3 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName3 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td class="pt-4 text-left">
                ii. Project Lead (R2C & Incubation) - One
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingIncubationplYear1"
                      (input)="calculateTotal4()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingIncubationplYear2"
                      (input)="calculateTotal4()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownRecurryingIncubationplTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows file-width mt-3" *ngIf="!showForm">
                  <label
                    *ngIf="disName4 != '✔ Uploaded'"
                    for="input-file-id4"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName4 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id4"
                      type="file"
                      (change)="fileUpload4($event)"
                    />
                  </label>
                  <label
                    *ngIf="disName4 == '✔ Uploaded'"
                    for="input-file-id4"
                    class="md-button md-raised md-accent"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName4 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id4"
                      type="file"
                      (change)="fileUpload4($event)"
                    />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p *ngIf="fileErrorShow4 == true" class="text-danger">
                    File size exceeds the limit ({{ maxSizeMB4 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames4 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName4 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>

                <div
                  class="form-rows file-width mt-3"
                  *ngIf="showForm"
                  disabled
                >
                  <label
                    *ngIf="disName4 != '✔ Uploaded'"
                    for="input-file-id4"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName4 }}</span>
                    <input class="d-none" id="input-file-id4" readonly />
                  </label>
                  <label
                    *ngIf="disName4 == '✔ Uploaded'"
                    for="input-file-id4"
                    class="md-button md-raised md-accent"
                    style="cursor: not-allowed"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName4 }}</span>
                    <input class="d-none" id="input-file-id4" readonly />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p
                    *ngIf="
                      logoCheck4 &&
                      selecetdFile4 &&
                      selecetdFile4.size / (1024 * 1024) > maxSizeMB4
                    "
                    class="text-danger"
                  >
                    File size exceeds the limit ({{ maxSizeMB4 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames4 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName4 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td class="pt-4 text-left">
                iii. Project Lead (Marketing & CSR) - One
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingMarketingplYear1"
                      (input)="calculateTotal5()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingMarketingplYear2"
                      (input)="calculateTotal5()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownRecurryingMarketingplTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows file-width mt-3" *ngIf="!showForm">
                  <label
                    *ngIf="disName5 != '✔ Uploaded'"
                    for="input-file-id5"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName5 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id5"
                      type="file"
                      (change)="fileUpload5($event)"
                    />
                  </label>
                  <label
                    *ngIf="disName5 == '✔ Uploaded'"
                    for="input-file-id5"
                    class="md-button md-raised md-accent"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName5 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id5"
                      type="file"
                      (change)="fileUpload5($event)"
                    />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p *ngIf="fileErrorShow5 == true" class="text-danger">
                    File size exceeds the limit ({{ maxSizeMB5 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames5 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName5 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
                <div
                  class="form-rows file-width mt-3"
                  *ngIf="showForm"
                  disabled
                >
                  <label
                    *ngIf="disName5 != '✔ Uploaded'"
                    for="input-file-id5"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName5 }}</span>
                    <input class="d-none" id="input-file-id5" readonly />
                  </label>
                  <label
                    *ngIf="disName5 == '✔ Uploaded'"
                    for="input-file-id5"
                    class="md-button md-raised md-accent"
                    style="cursor: not-allowed"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName5 }}</span>
                    <input class="d-none" id="input-file-id5" readonly />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p
                    *ngIf="
                      logoCheck5 &&
                      selecetdFile5 &&
                      selecetdFile5.size / (1024 * 1024) > maxSizeMB5
                    "
                    class="text-danger"
                  >
                    File size exceeds the limit ({{ maxSizeMB5 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames5 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName5 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td class="pt-4 text-left">iv. Project Associate - Three</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingProjectAssociateYear1"
                      (input)="calculateTotal6()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingProjectAssociateYear2"
                      (input)="calculateTotal6()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownRecurryingProjectAssociateTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows file-width mt-3" *ngIf="!showForm">
                  <label
                    *ngIf="disName6 != '✔ Uploaded'"
                    for="input-file-id6"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName6 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id6"
                      type="file"
                      (change)="fileUpload6($event)"
                    />
                  </label>
                  <label
                    *ngIf="disName6 == '✔ Uploaded'"
                    for="input-file-id6"
                    class="md-button md-raised md-accent"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName6 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id6"
                      type="file"
                      (change)="fileUpload6($event)"
                    />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p *ngIf="fileErrorShow6 == true" class="text-danger">
                    File size exceeds the limit ({{ maxSizeMB6 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames6 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName6 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
                <div
                  class="form-rows file-width mt-3"
                  *ngIf="showForm"
                  disabled
                >
                  <label
                    *ngIf="disName6 != '✔ Uploaded'"
                    for="input-file-id6"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName6 }}</span>
                    <input class="d-none" id="input-file-id6" readonly />
                  </label>
                  <label
                    *ngIf="disName6 == '✔ Uploaded'"
                    for="input-file-id6"
                    class="md-button md-raised md-accent"
                    style="cursor: not-allowed"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName6 }}</span>
                    <input class="d-none" id="input-file-id6" readonly />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p
                    *ngIf="
                      logoCheck6 &&
                      selecetdFile6 &&
                      selecetdFile6.size / (1024 * 1024) > maxSizeMB6
                    "
                    class="text-danger"
                  >
                    File size exceeds the limit ({{ maxSizeMB6 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames6 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName6 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">b</th>
              <td class="pt-4 text-left">Utility and Maintenance</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingUtilityYear1"
                      (input)="calculateTotal7()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingUtilityYear2"
                      (input)="calculateTotal7()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownRecurryingUtilityTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows file-width mt-3" *ngIf="!showForm">
                  <label
                    *ngIf="disName7 != '✔ Uploaded'"
                    for="input-file-id7"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName7 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id7"
                      type="file"
                      (change)="fileUpload7($event)"
                    />
                  </label>
                  <label
                    *ngIf="disName7 == '✔ Uploaded'"
                    for="input-file-id7"
                    class="md-button md-raised md-accent"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName7 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id7"
                      type="file"
                      (change)="fileUpload7($event)"
                    />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p *ngIf="fileErrorShow7 == true" class="text-danger">
                    File size exceeds the limit ({{ maxSizeMB7 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames7 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName7 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
                <div
                  class="form-rows file-width mt-3"
                  *ngIf="showForm"
                  disabled
                >
                  <label
                    *ngIf="disName7 != '✔ Uploaded'"
                    for="input-file-id7"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName7 }}</span>
                    <input class="d-none" id="input-file-id7" readonly />
                  </label>
                  <label
                    *ngIf="disName7 == '✔ Uploaded'"
                    for="input-file-id7"
                    class="md-button md-raised md-accent"
                    style="cursor: not-allowed"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName7 }}</span>
                    <input class="d-none" id="input-file-id7" readonly />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p
                    *ngIf="
                      logoCheck7 &&
                      selecetdFile7 &&
                      selecetdFile7.size / (1024 * 1024) > maxSizeMB7
                    "
                    class="text-danger"
                  >
                    File size exceeds the limit ({{ maxSizeMB7 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames7 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName7 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">c</th>
              <td class="pt-4 text-left">Marketing Promotion and Publicity</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingMarketingYear1"
                      (input)="calculateTotal8()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingMarketingYear2"
                      (input)="calculateTotal8()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownRecurryingMarketingTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows file-width mt-3" *ngIf="!showForm">
                  <label
                    *ngIf="disName8 != '✔ Uploaded'"
                    for="input-file-id8"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName8 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id8"
                      type="file"
                      (change)="fileUpload8($event)"
                    />
                  </label>
                  <label
                    *ngIf="disName8 == '✔ Uploaded'"
                    for="input-file-id8"
                    class="md-button md-raised md-accent"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName8 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id8"
                      type="file"
                      (change)="fileUpload8($event)"
                    />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p *ngIf="fileErrorShow8 == true" class="text-danger">
                    File size exceeds the limit ({{ maxSizeMB8 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames8 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName8 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
                <div
                  class="form-rows file-width mt-3"
                  *ngIf="showForm"
                  disabled
                >
                  <label
                    *ngIf="disName8 != '✔ Uploaded'"
                    for="input-file-id8"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName8 }}</span>
                    <input class="d-none" id="input-file-id8" readonly />
                  </label>
                  <label
                    *ngIf="disName8 == '✔ Uploaded'"
                    for="input-file-id8"
                    class="md-button md-raised md-accent"
                    style="cursor: not-allowed"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName8 }}</span>
                    <input class="d-none" id="input-file-id8" readonly />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p
                    *ngIf="
                      logoCheck8 &&
                      selecetdFile8 &&
                      selecetdFile8.size / (1024 * 1024) > maxSizeMB8
                    "
                    class="text-danger"
                  >
                    File size exceeds the limit ({{ maxSizeMB8 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames8 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName8 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">d</th>
              <td class="pt-4 text-left">Networking and Training Programmes</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingNetworkingYear1"
                      (input)="calculateTotal9()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingNetworkingYear2"
                      (input)="calculateTotal9()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownRecurryingNetworkingTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows file-width mt-3" *ngIf="!showForm">
                  <label
                    *ngIf="disName9 != '✔ Uploaded'"
                    for="input-file-id9"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName9 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id9"
                      type="file"
                      (change)="fileUpload9($event)"
                    />
                  </label>
                  <label
                    *ngIf="disName9 == '✔ Uploaded'"
                    for="input-file-id9"
                    class="md-button md-raised md-accent"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName9 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id9"
                      type="file"
                      (change)="fileUpload9($event)"
                    />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p *ngIf="fileErrorShow9 == true" class="text-danger">
                    File size exceeds the limit ({{ maxSizeMB9 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames9 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName9 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
                <div
                  class="form-rows file-width mt-3"
                  *ngIf="showForm"
                  disabled
                >
                  <label
                    *ngIf="disName9 != '✔ Uploaded'"
                    for="input-file-id9"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName9 }}</span>
                    <input class="d-none" id="input-file-id9" readonly />
                  </label>
                  <label
                    *ngIf="disName9 == '✔ Uploaded'"
                    for="input-file-id9"
                    class="md-button md-raised md-accent"
                    style="cursor: not-allowed"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName9 }}</span>
                    <input class="d-none" id="input-file-id9" readonly />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p
                    *ngIf="
                      logoCheck9 &&
                      selecetdFile9 &&
                      selecetdFile9.size / (1024 * 1024) > maxSizeMB9
                    "
                    class="text-danger"
                  >
                    File size exceeds the limit ({{ maxSizeMB9 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames9 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName9 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">e</th>
              <td class="pt-4 text-left">Administrative Overheads</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingAdministrativeOverheadYear1"
                      (input)="calculateTotal10()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingAdministrativeOverheadYear2"
                      (input)="calculateTotal10()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownRecurryingAdministrativeOverheadTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows file-width mt-3" *ngIf="!showForm">
                  <label
                    *ngIf="disName10 != '✔ Uploaded'"
                    for="input-file-id10"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName10 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id10"
                      type="file"
                      (change)="fileUpload10($event)"
                    />
                  </label>
                  <label
                    *ngIf="disName10 == '✔ Uploaded'"
                    for="input-file-id10"
                    class="md-button md-raised md-accent"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName10 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id10"
                      type="file"
                      (change)="fileUpload10($event)"
                    />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p *ngIf="fileErrorShow10 == true" class="text-danger">
                    File size exceeds the limit ({{ maxSizeMB10 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames10 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName10 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
                <div
                  class="form-rows file-width mt-3"
                  *ngIf="showForm"
                  disabled
                >
                  <label
                    *ngIf="disName10 != '✔ Uploaded'"
                    for="input-file-id10"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName10 }}</span>
                    <input class="d-none" id="input-file-id10" readonly />
                  </label>
                  <label
                    *ngIf="disName10 == '✔ Uploaded'"
                    for="input-file-id10"
                    class="md-button md-raised md-accent"
                    style="cursor: not-allowed"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName10 }}</span>
                    <input class="d-none" id="input-file-id10" readonly />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p
                    *ngIf="
                      logoCheck10 &&
                      selecetdFile10 &&
                      selecetdFile10.size / (1024 * 1024) > maxSizeMB10
                    "
                    class="text-danger"
                  >
                    File size exceeds the limit ({{ maxSizeMB10 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames10 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName10 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">f</th>
              <td class="pt-4 text-left">
                Consumables including printing, books, etc
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingConsumablesYear1"
                      (input)="calculateTotal11()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingConsumablesYear2"
                      (input)="calculateTotal11()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownRecurryingConsumablesTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows file-width mt-3" *ngIf="!showForm">
                  <label
                    *ngIf="disName11 != '✔ Uploaded'"
                    for="input-file-id11"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName11 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id11"
                      type="file"
                      (change)="fileUpload11($event)"
                    />
                  </label>
                  <label
                    *ngIf="disName11 == '✔ Uploaded'"
                    for="input-file-id11"
                    class="md-button md-raised md-accent"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName11 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id11"
                      type="file"
                      (change)="fileUpload11($event)"
                    />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p *ngIf="fileErrorShow11 == true" class="text-danger">
                    File size exceeds the limit ({{ maxSizeMB11 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames11 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName11 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
                <div
                  class="form-rows file-width mt-3"
                  *ngIf="showForm"
                  disabled
                >
                  <label
                    *ngIf="disName11 != '✔ Uploaded'"
                    for="input-file-id11"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName11 }}</span>
                    <input class="d-none" id="input-file-id11" readonly />
                  </label>
                  <label
                    *ngIf="disName11 == '✔ Uploaded'"
                    for="input-file-id11"
                    class="md-button md-raised md-accent"
                    style="cursor: not-allowed"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName11 }}</span>
                    <input class="d-none" id="input-file-id11" readonly />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p
                    *ngIf="
                      logoCheck11 &&
                      selecetdFile11 &&
                      selecetdFile11.size / (1024 * 1024) > maxSizeMB11
                    "
                    class="text-danger"
                  >
                    File size exceeds the limit ({{ maxSizeMB11 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames11 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName11 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">g</th>
              <td class="pt-4 text-left">Miscellaneous</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingMiscellaneousYear1"
                      (input)="calculateTotal12()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownRecurryingMiscellaneousYear2"
                      (input)="calculateTotal12()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownRecurryingMiscellaneousTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows file-width mt-3" *ngIf="!showForm">
                  <label
                    *ngIf="disName12 != '✔ Uploaded'"
                    for="input-file-id12"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName12 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id12"
                      type="file"
                      (change)="fileUpload12($event)"
                    />
                  </label>
                  <label
                    *ngIf="disName12 == '✔ Uploaded'"
                    for="input-file-id12"
                    class="md-button md-raised md-accent"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName12 }}</span>
                    <input
                      class="d-none"
                      id="input-file-id12"
                      type="file"
                      (change)="fileUpload12($event)"
                    />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p *ngIf="fileErrorShow12 == true" class="text-danger">
                    File size exceeds the limit ({{ maxSizeMB12 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames12 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName12 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
                <div
                  class="form-rows file-width mt-3"
                  *ngIf="showForm"
                  disabled
                >
                  <label
                    *ngIf="disName12 != '✔ Uploaded'"
                    for="input-file-id12"
                    class="md-button md-raised md-primary"
                  >
                    Choose File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName12 }}</span>
                    <input class="d-none" id="input-file-id12" readonly />
                  </label>
                  <label
                    *ngIf="disName12 == '✔ Uploaded'"
                    for="input-file-id12"
                    class="md-button md-raised md-accent"
                    style="cursor: not-allowed"
                  >
                    Update File
                    <ion-icon
                      class="ml-3"
                      name="cloud-upload-outline"
                    ></ion-icon>
                    <span class="ml-3">{{ disName12 }}</span>
                    <input class="d-none" id="input-file-id12" readonly />
                  </label>
                  <span class="noti-span">
                    (Supported Format: pdf) (max file size: 5mb)
                  </span>
                  <p
                    *ngIf="
                      logoCheck12 &&
                      selecetdFile12 &&
                      selecetdFile12.size / (1024 * 1024) > maxSizeMB12
                    "
                    class="text-danger"
                  >
                    File size exceeds the limit ({{ maxSizeMB12 }}MB)
                  </p>
                  <div
                    class="mt-2 mb-3"
                    *ngIf="disNames12 == '✔ Uploaded' && getValue"
                  >
                    <a class="pdf-btn" href="{{ FileName12 }}" target="_blank"
                      >Download & View Document</a
                    >
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td class="pt-4 text-right">Total(2)</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownRecurryingYear1Total"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownRecurryingYear2Total"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownRecurryingTotal"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td></td>
              <td></td>
              <td class="pt-4 text-right"><b>3.Contribution**</b></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">a</th>
              <td class="pt-4 text-left">
                <p>
                  StartupTN’s Contribution <br />(40% to the max. of 100 lakhs)
                </p>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownStartuptnContributionYear1"
                      (input)="calculateTotal13()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownStartuptnContributionYear2"
                      (input)="calculateTotal13()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownStartuptnContributionTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">b</th>
              <td class="pt-4 text-left">
                <p>
                  Host Institution Contribution <br />(40% of the proposed
                  budget)
                </p>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownHostIncContributionYear1"
                      (input)="calculateTotal14()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownHostIncContributionYear2"
                      (input)="calculateTotal14()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownHostIncContributionTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" class="pt-4">c</th>
              <td class="pt-4 text-left">
                <p>
                  Industry/Corporate Partner Contribution <br />(20% of the
                  proposed budget)
                </p>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownIndustryContributionYear1"
                      (input)="calculateTotal15()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Enter Amount"
                      type="text"
                      readonly="{{ showForm }}"
                      formControlName="budgetBreakdownIndustryContributionYear2"
                      (input)="calculateTotal15()"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                      maxlength="11"
                      (keydown.enter)="preventEnterKey($event)"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownIndustryContributionTotalYear"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td></td>
            </tr>
            <tr>
              <th scope="row" class="pt-4"></th>
              <td class="pt-4 text-right">Total (3a + 3b + 3c)</td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR) </mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownTotala"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownTotalb"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td>
                <div class="form-rows">
                  <mat-form-field
                    class="material-full-width"
                    appearance="outline"
                  >
                    <mat-label>Total Amount (INR)</mat-label>
                    <input
                      matInput
                      placeholder="Total Amount"
                      type="text"
                      readonly
                      formControlName="budgetBreakdownTotalc"
                      oninput="this.value = this.value.replace(/^(\.)|^0+(?!\.)|[^0-9.]/g, '') .replace(/(\..*)\./g, '$1') .replace(/^(\d{8})\d*$/, '$1') .replace(/^(\d*\.\d{2})\d*$/, '$1')"
                    />
                  </mat-form-field>
                </div>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div class="col-12 p-3">
          <p class="sub-title">Description:</p>
        </div>
        <div class="ml-3">
          <p>
            1. * Budget to be submitted along with justification of each item
            and a list of indicating costs along with quotations for the thrust
            area equipment, office equipment under non-recurring expenditure as
            separate annexure
          </p>
          <p class="mt-2">
            2. ** Contribution of StartupTN and applicant should include both
            recurring and non-recurring expenses
          </p>
        </div>
      </div>
      <div class="text-center mt-3 mb-3">
        <button
          mat-raised-button
          color="primary"
          (click)="saveBtn('true')"
          *ngIf="!showForm"
        >
          Save & Next
        </button>
      </div>
    </form>
  </div>
</section>
